import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { DescriptionModes, SummaryTableDepths } from "@repo/utils";
import {
  useEstimateStructure,
  SummaryRow,
  AddChildTask,
  PinnableCell,
  useEstimateEditorSettings,
} from "@tools";

export const SectionSummaryRow = observer(({
  section,
  isFirst,
}) => {
  const {
    isLibrary,
    allowEdition,
    useVisibilityCell,
  } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  
  const { displayTwoValues, settings } = structure;
  const { descriptionMode } = settings;
  const { startingLevel } = section;

  return (
    <SummaryRow
      useVisibilityCell={useVisibilityCell}
      displayMinMax={displayTwoValues}
      presetClass="preset-page"
      tableDepth={0}
    >
      <PinnableCell
        tableDepth={-1}
        pinnedLeft
        stretchToChildrenWidth
        allowOverflowDisplay={descriptionMode < DescriptionModes.COLUMN}
      >
        {allowEdition && (
          <AddChildTask
            parent={section}
            tableDepth={isLibrary ? startingLevel : SummaryTableDepths.WORK_TYPE}
            showId={isFirst}
          />
        )}
      </PinnableCell>
    </SummaryRow>
  );
});

SectionSummaryRow.propTypes = {
  section: object.isRequired,
  isFirst: bool,
};
